const defaultFeatureToggleState = window.config.FEATURE_TOGGLES;

class FeatureToggles {
  #featureToggles;
  #storageKey;
  #storage;

  constructor(defaultFeatureToggleState, storageKey = 'featureToggles', storage = localStorage) {
    this.#storage = storage;
    this.#storageKey = storageKey;
    this.#featureToggles = { ...defaultFeatureToggleState, ...this.#getStoredState() };
  }

  #getStoredState() {
    return JSON.parse(this.#storage.getItem(this.#storageKey) || '{}');
  }

  #updateStoredState(feature, state) {
    const stored = this.#getStoredState();
    stored[feature] = state;
    this.#storage.setItem(this.#storageKey, JSON.stringify(stored));
  }

  get(feature) {
    return this.#featureToggles[feature] ?? false;
  }

  set(feature, state) {
    this.#updateStoredState(feature, state);
    this.#featureToggles[feature] = state;
  }
}

window.featureToggles = new FeatureToggles(defaultFeatureToggleState);
